// src/hooks/useStripePlanStatus.ts
import useSWR from "swr";
import { useAuthContext } from "@/contexts/AuthContext";

const fetcher = async (url: string) => {
  const res = await fetch(url, { cache: "no-store" });
  // 🔒 HTML(404等)が返ってくると res.json() で死ぬのでガード
  const ct = res.headers.get("content-type") || "";
  if (!ct.includes("application/json")) {
    return {
      effectiveState: "free",
      effective_plan: "free",
      stripe: { rawStatus: null, cancelAtPeriodEnd: false, currentPeriodEnd: null, trialEnd: null },
      entitlements: { overrideActive: false, overridePlan: null, overrideExpiresAt: null, facilitatorActive: false, canDistribute: false },
      billing: { hasPaymentMethod: false, defaultPaymentMethodId: null, defaultPaymentMethodSummary: null },
      user_plan: "free",
      subscriptionCancelAt: null,
      subscriptionCanceledAt: null,
      nextPlan: null,
      nextPlanStartDate: null,
      trialActive: false,
      trialEnd: null,
      _nonJson: true,
      _status: res.status,
    };
  }
  return res.json();
};

// サーバーの返す形に合わせて“処理中”判定を調整してください
const isPending = (d: any) => {
  // 新APIでは rawStatus を見るのが筋（昔のstatus系にも一応対応）
  const s =
    d?.stripe?.rawStatus ?? d?.status ?? d?.planStatus ?? d?.state;
  return s === "incomplete" || s === "pending" || s === "processing";
};

export function useStripePlanStatus() {
  const { clerkUser } = useAuthContext();
  const userId = clerkUser?.id;

  const { data, error, isLoading, mutate } = useSWR(
    // ✅ userId は送らない（サーバ側 auth() で確定）
    userId ? `/api/stripe/user-status` : null,
    fetcher,
    {
      // ← ここがポイント：処理中だけ 5s 間隔、それ以外は停止
      refreshInterval: (data) => (isPending(data) ? 5000 : 0),
      revalidateOnFocus: true,         // タブ復帰時に一度だけ確認
      revalidateOnReconnect: true,
      dedupingInterval: 5000,          // 連打抑制（安全弁）
      // refreshWhenHidden: false,     // デフォルトfalse（必要なら明示）
    }
  );

  return { status: data, loading: isLoading, error, refetch: mutate };
}
